import { ClaimGroup as BaseClaimGroup } from '@rd-web-markets/shared/dist/models/ClaimGroup';
import { isUserCustomer } from '@rd-web-markets/shared/dist/util/user/userUtils';
export class ClaimGroup extends BaseClaimGroup {
  isSmeOrRdec() {
    return this.claimGroup.rate_types_qualified_for?.sme || this.claimGroup.rate_types_qualified_for?.rdec || this.claimGroup.rate_types_qualified_for?.sme_and_rdec || false;
  }
  isSmeAndRdec() {
    return this.claimGroup.rate_types_qualified_for?.sme_and_rdec || false;
  }
  getOverviewLink(user) {
    const isCustomer = isUserCustomer(user);
    if (isCustomer && this.claimGroup.company?.dashboard_type) {
      const basePath = `/customer/claim_groups/${this.claimGroup.id}`;
      return this.claimGroup.company.dashboard_type === 'business_unit_intensity_breakdown' ? `${basePath}/regular_realtime_dashboard/${this.claimGroup.company_id}` : `${basePath}/dashboard/${this.claimGroup.company_id}`;
    } else {
      return super.getOverviewLink(user);
    }
  }
  static load(claimGroupJsonObject) {
    return new ClaimGroup(claimGroupJsonObject);
  }
}